import WholesalersSection from "./sections/wholesalersSection";

export default function wholesalers() {
    const wholesalers = document.querySelectorAll('[data-wholesalers]')
    wholesalers.forEach(section => new WholesalersSection(section));
}